import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SecurityAlertProps {
  event: {
    type: string;
    timestamp: string;
    metadata: {
      user_agent?: string;
      city?: string;
    };
  };
  onDismiss: () => void;
}

export function SecurityAlert({ event, onDismiss }: SecurityAlertProps) {
  const { metadata, timestamp } = event;
  
  return (
    <div className="mx-6 my-4 max-w-4xl">
      <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-4 shadow-sm">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-yellow-600 flex-shrink-0 mt-0.5" />
          
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-yellow-900 mb-1">
              Nuevo inicio de sesión detectado
            </h3>
            <p className="text-sm text-yellow-800 mb-2">
              Se ha detectado un nuevo inicio de sesión desde un dispositivo desconocido.
              Revisa tus sesiones en Configuración &gt; Seguridad.
            </p>
            
            <div className="text-xs text-yellow-700 space-y-1">
              {metadata.user_agent && (
                <p>
                  <strong>Dispositivo:</strong> {metadata.user_agent}
                </p>
              )}
              {metadata.city && (
                <p>
                  <strong>Ubicación:</strong> {metadata.city}
                </p>
              )}
              <p>
                <strong>Fecha:</strong> {new Date(timestamp).toLocaleString('es-ES')}
              </p>
            </div>
          </div>

          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
            className="h-6 w-6 p-0 hover:bg-yellow-100"
          >
            <X className="h-4 w-4 text-yellow-600" />
          </Button>
        </div>
      </div>
    </div>
  );
}
